module.exports = __webpack_public_path__ + "img/0-102.a440d58a.jpg";